{
  "alert": "התראה",
  "dismiss": "התעלם"
}
